




























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  tableData: Array<Object>;

  search = '';

  odnowDialogVisible = false;

  poinformujDialogVisible = false;

  entryDialogVisible = false;

  form = {
    name: '',
    region: '',
    date1: '',
    date2: '',
    delivery: false,
    type: [],
    resource: '',
    desc: '',
  };

  najemcaTableData = [{
    from: '2020-01-05',
    to: '2021-01-05',
    delay: 2,
  }, {
    from: '2019-01-03',
    to: '2020-01-03',
    delay: 0,
  }];

  przegladyTableData = [{
    to: '2019-12-05',
    left: '-31',
    name: 'Wentylacja',
  }, {
    to: '2020-12-05',
    left: '352',
    name: 'Gaz',
  }, {
    to: '2020-02-05',
    left: '30',
    name: 'Oświetlenie',
  }, {
    to: '2020-12-05',
    left: '351',
    name: 'Klimatyzacja',
  }];

  constructor() {
    super();
    this.tableData = [{
      status: 'aktualny',
      nrLokalu: '341/1',
      okresWaznosciWDniach: '365',
      liczbaDniDoNastepnegoBadania: '120',
      nazwa: 'House',
      dataWykonaniaPrzegladu: '2020-01-02',
      terminNastepnegoBadania: '2021-01-02',
      email: 'email@example.com',
      phone: '123-456-789',
    }, {
      status: 'przedawniony',
      nrLokalu: '341/1',
      okresWaznosciWDniach: '365',
      liczbaDniDoNastepnegoBadania: '120',
      nazwa: 'C&A',
      dataWykonaniaPrzegladu: '2018-05-03',
      terminNastepnegoBadania: '2019-05-03',
      email: 'email@example.com',
      phone: '123-456-789',
    }, {
      status: 'kończący się',
      nrLokalu: '341/1',
      okresWaznosciWDniach: '365',
      liczbaDniDoNastepnegoBadania: '120',
      nazwa: 'Butik',
      dataWykonaniaPrzegladu: '2019-02-01',
      terminNastepnegoBadania: '2020-02-01',
      email: 'email@example.com',
      phone: '123-456-789',
    }, {
      status: 'aktualny',
      nrLokalu: '341/1',
      okresWaznosciWDniach: '365',
      liczbaDniDoNastepnegoBadania: '120',
      nazwa: 'House',
      dataWykonaniaPrzegladu: '2020-01-02',
      terminNastepnegoBadania: '2021-01-02',
      email: 'email@example.com',
      phone: '123-456-789',
    }, {
      status: 'przedawniony',
      nrLokalu: '341/1',
      okresWaznosciWDniach: '365',
      liczbaDniDoNastepnegoBadania: '120',
      nazwa: 'C&A',
      dataWykonaniaPrzegladu: '2018-05-03',
      terminNastepnegoBadania: '2019-05-03',
      email: 'email@example.com',
      phone: '123-456-789',
    }, {
      status: 'kończący się',
      nrLokalu: '341/1',
      okresWaznosciWDniach: '365',
      liczbaDniDoNastepnegoBadania: '120',
      nazwa: 'Butik',
      dataWykonaniaPrzegladu: '2019-02-01',
      terminNastepnegoBadania: '2020-02-01',
      email: 'email@example.com',
      phone: '123-456-789',
    }];
  }

  // eslint-disable-next-line class-methods-use-this
  filterHandler(value: any, row: any, column: any) {
    // eslint-disable-next-line prefer-destructuring
    const property = column.property;
    return row[property] === value;
  }
}
